import { render, staticRenderFns } from "./memberTag.vue?vue&type=template&id=b2dc60ee&scoped=true&"
import script from "./memberTag.vue?vue&type=script&lang=js&"
export * from "./memberTag.vue?vue&type=script&lang=js&"
import style0 from "./memberTag.vue?vue&type=style&index=0&id=b2dc60ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc60ee",
  null
  
)

component.options.__file = "memberTag.vue"
export default component.exports